import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Text } from "../ui/text";
import RightArrowIcon from "../ui/icons/RightArrowIcon";
import { Button } from "../ui/button";
import CustomPagination from "../ui/custom-pagination";
import { useState } from "react";
import JobSelectTable from "./job-select-table";
import useJobStatusQuery from "@/hooks/services/queries/job-status/use-job-status-query";
import { useAiAgentStore } from "@/stores/ai-agent";
import { JobStatusTableData } from "@/types/job-status";
import { overlay } from "overlay-kit";

// Dialog 내용 컴포넌트 (overlay.open으로 열림)
interface JobSelectDialogContentProps {
  isOpen: boolean;
  close: () => void;
}

const JobSelectDialogContent = ({
  isOpen,
  close,
}: JobSelectDialogContentProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tempSelectedJob, setTempSelectedJob] =
    useState<JobStatusTableData | null>(null);

  const { setSelectedJob } = useAiAgentStore();

  const { data: tableData } = useJobStatusQuery({
    page: currentPage,
    perPage: 10,
    isRefetching: false,
  });

  const handleChangePage = (page: number) => {
    setCurrentPage(page);
  };

  const handleSelectJob = (job: JobStatusTableData) => {
    // 같은 Job을 다시 클릭하면 선택 해제, 다른 Job을 클릭하면 새로운 Job 선택
    setTempSelectedJob((prev) =>
      prev?.analysisNo === job.analysisNo ? null : job
    );
  };

  const handleSelect = () => {
    setSelectedJob(tempSelectedJob);
    close();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && close()}>
      <DialogContent className="w-[calc(100vw-32px)] max-w-[1190px] flex flex-col gap-[24px] pb-[24px] pt-2 rounded-[10px]">
        <DialogHeader>
          <div className="flex justify-between items-center px-[16px] md:px-[36px] pb-2">
            <DialogTitle className="text-[22px] font-[800] leading-[28px] font-pretendard">
              SDF Job
            </DialogTitle>
            <div className="flex gap-2 pt-[24px]">
              <Button variant={"secondary"} size={"md"} onClick={close}>
                <Text variant={"title-md"} className="text-grey-20">
                  Cancel
                </Text>
              </Button>
              <Button variant={"primary"} size={"md"} onClick={handleSelect}>
                <Text variant={"title-md"} className="text-white">
                  Select
                </Text>
              </Button>
            </div>
          </div>
        </DialogHeader>
        <div className="px-[16px] md:px-[36px] h-[550px] overflow-x-auto">
          <JobSelectTable
            tableData={
              (tableData?.content ?? []) as unknown as JobStatusTableData[]
            }
            handleSelectJob={handleSelectJob}
            selectedJob={tempSelectedJob}
          />
        </div>
        <div className="flex justify-center">
          <CustomPagination
            currentPage={currentPage}
            totalPages={tableData?.totalPages || 0}
            onChange={handleChangePage}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

// overlay.open을 통해 Dialog를 여는 함수
export const openJobSelectDialog = () => {
  overlay.open(({ isOpen, close }) => (
    <JobSelectDialogContent isOpen={isOpen} close={close} />
  ));
};

// 트리거 버튼 컴포넌트
interface JobSelectTriggerProps {
  onClick?: () => void;
}

export const JobSelectTrigger = ({ onClick }: JobSelectTriggerProps) => {
  const handleClick = () => {
    onClick?.();
    openJobSelectDialog();
  };

  return (
    <button
      onClick={handleClick}
      className="w-[158px] border border-primary-50 rounded-[8px] pl-4 pr-1 h-[40px] flex items-center justify-between"
      style={{
        background:
          "linear-gradient(144deg, #ECFCFA 13.78%, #FEF9F7 49.93%, #FFF 86.08%)",
      }}
    >
      <Text variant={"label-lg"} className="text-grey-20">
        SDF Job
      </Text>
      <div className="w-[24px] h-[24px] flex items-center justify-center">
        <RightArrowIcon color="#333333" />
      </div>
    </button>
  );
};

export default JobSelectTrigger;
